/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { getRequest, delRequest, postRequest } from "../../axiosRoutes/index";
import {
  Button,
  Box,
  CircularProgress,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Pagination,
  Snackbar,
  Alert,
  Card,
  CardContent,
  CardActions,
  useMediaQuery,
} from "@mui/material";
import SideNavBar from "../sidebar/SideNav";
import HrSideNavBar from "../sidebar/HrSideNavBar";
import AddSalary from "./AddSalary";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "../../axiosRoutes/snackbarConfig";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useInView } from 'react-intersection-observer';
import DownloadIcon from '@mui/icons-material/Download';
import axios from 'axios'

const getCurrentMonthYear = () => {
  const now = new Date();
  const month = now.getMonth() + 1;
  const year = now.getFullYear();
  return `${month}/${year}`;
};

const Salaries = () => {
  // eslint-disable-next-line no-unused-vars
  const [silentLoading, setSilentLoading] = useState(false);
  const { snackbar, showSnackbar, handleSnackbarClose } = useSnackbar();
  const [hover, setHover] = useState(null);
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const [salaries, setSalaries] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [salaryId, setSalaryId] = useState(null);
  const [openSalary, setOpenSalary] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const role = localStorage.getItem("role");
  const [totalSalaries, setTotalSalaries] = useState({
    payableSalary: 0,
    month: "",
  });
  const [salaryData, setSalaryData] = useState({
    name: "",
    grossSalary: 0,
    netSalary: 0,
    medical: 0,
    fitness: 0,
    deduction: 0,
    tax: 0,
    salaryMonth: "",
    status: "",
  });
  const [selectedMonth, setSelectedMonth] = useState(getCurrentMonthYear());
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [isFetchingSalaries, setIsFetchingSalaries] = useState(false)
  const { ref, inView } = useInView({
      threshold: 0,
  });
  const [limit, setLimit] = useState(10)
  const selectedDate = useRef(getCurrentMonthYear)
  const [salarySlipDownloadIds, setSalarySlipDownloadIds] = useState([])

  useEffect(() => {
      if (inView) {
        if(limit < totalPages * 10){
          setLimit(prev=>prev+10)
        }
      }
    }, [inView]);
  
  const handleMonthChange = (date) => {
    if (date) {
      const formattedDate = dayjs(date).format("M/YYYY")
      selectedDate.current = formattedDate
    }
  };

  const handleDateClose = () => {
    if(selectedDate.current){
      setSelectedMonth(selectedDate.current)
    }
  };

  const fetchStatus = async () => {
    try {
      const response = await getRequest("filter/status");
      const statusArray = Object.keys(response).map((key) => ({
        label: key,
        value: response[key],
      }));
      setStatuses(statusArray);
    } catch (error) {
      console.error("Error fetching Filter:", error);
    }
  };
  const fetchSalaries = async (silent = false) => {
    try {
      const access = localStorage.getItem("access");
      if (!silent && !isSmallScreen) setLoading(true);
      else setSilentLoading(true);
      setIsFetchingSalaries(true)
      let res = await postRequest(
        `admin/salary/month?${!isSmallScreen ? `page=${page}` : `limit=${limit}`}`,
        {
          Authorization: `Bearer ${access}`,
        },
        { salaryMonth: selectedMonth }
      );
      setIsFetchingSalaries(false)
      setTotalPages(res?.data?.totals?.total_pages)
      let total_amount = res?.data?.totals?.total_amount
      setTotalSalaries((prevData) => ({
        ...prevData,
        payableSalary: total_amount,
        month: formattedMonth,
      }));
      const response = res.data.data
      const [curMonth, curYear] = selectedMonth.split("/");
      const curDate = new Date(`${curYear}-${curMonth}-01`);
      const formattedMonth = curDate.toLocaleDateString("en-US", {
        month: "long",
        year: "numeric",
      });
      const formattedSalaries = response.map((salary) => {
        const statusObj = statuses.find(
          (status) => status.value === salary.status
        );
        salary.status = statusObj ? statusObj.label : salary.status;
        return salary;
      });
      setSalaries(formattedSalaries)
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    } finally {
      if (!silent) setLoading(false);
      else setSilentLoading(false);
    }
  };

  useEffect(() => {
    if (statuses.length > 0) {
      fetchSalaries();
    }
  }, [statuses]);

  useEffect(() => {
    setPage(1)
    const fetchAndSetData = async () => {
      await fetchStatus();
    };
    fetchAndSetData();
  }, [selectedMonth]);
  useEffect(()=>{
    fetchStatus()
    const interval = setInterval(()=>{fetchSalaries(true)}, 15000)
    return () => clearInterval(interval)
  }, [page, limit, selectedMonth])

  const handleDelete = async () => {
    try {
      const access = localStorage.getItem("access");
      const response = await delRequest(`admin/salary/${deleteId}`, access);
      handleClose();
      showSnackbar(response, "success");
      fetchSalaries(true);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const handleSalary = async () => {
    try {
      showSnackbar("Generating salary records. Please wait for a Minute...", "info");

      const access = localStorage.getItem("access");
      const res = await postRequest(
        "admin/salary/generate-new-salary-records",
        {
          Authorization: `Bearer ${access}`,
        }
      );
      setTimeout(() => {
        fetchSalaries(true);
        showSnackbar(res.data, "success");
      }, 30000);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const handleMonthlySalaryReport = async() => {
    try{
      const access = localStorage.getItem("access")
      const res = await postRequest(
        "admin/salary/monthly-salary",
        {
          Authorization: `Bearer ${access}`,
          
        }
      )
      if(res?.data?.message){
        showSnackbar('PDF Monthly Salary Report will be mailed shortly', 'success')
      }
    }catch(error){
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  }

  const handleSalaryMail = async () => {
    try {
      const access = localStorage.getItem("access");
      const res = await getRequest("admin/salary/generate-salary-slips", {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      showSnackbar(res, "success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClickOpen = (id) => {
    setDeleteId(id);
    setOpen(true);
  };

  const handleMail = async (id, month) => {
    try {
      const access = localStorage.getItem("access");
      const res = await postRequest(
        `admin/salary/${id}`,
        {
          Authorization: `Bearer ${access}`,
        },
        { salaryMonth: month }
      );
      showSnackbar(res.data, "success");
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
  };

  const handleDownload = async(id, month, name) => {
    showSnackbar('PDF will be downloaded shortly.', "success");
    try {
      const access = localStorage.getItem("access");
      setSalarySlipDownloadIds(prev=> [...prev, id])
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}admin/salary/user/${id}/download`,
        { salaryMonth: month },
        {
          headers: {
            Authorization: `Bearer ${access}`,
            "Content-Type": "application/json",
          },
          responseType: 'blob',
        }
      );
      const blob = await res.data;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `salary_slip_${name.replace(/\s+/g, '_')}_${month.replace('/', '-')}.pdf`;; 
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "An error occurred";
      showSnackbar(errorMessage, "error");
    }
    finally{
      setSalarySlipDownloadIds(prev=> prev.filter(item => item !==id))
    }
  }

  const selectSalary = (id) => {
    setUpdateId(id);
    handleOpen();
  };

  const handleSalaryDetail = (id) => {
    setOpenSalary(true);
    setSalaryId(id);
  };

  useEffect(() => {
    const fetchSalary = async () => {
      if (salaryId !== null) {
        const access = localStorage.getItem("access");
        try {
          setLoading(true);
          const res = await getRequest(`admin/salary/${salaryId}`, {
            headers: {
              Authorization: `Bearer ${access}`,
            },
          });
          let returnStatus = () => {
            return statuses.find(
                        (status) => status.value === res.status
                    )?.label
          }
          setSalaryData({
            name: res.name,
            grossSalary: res.grossSalary,
            netSalary: res.netSalary,
            medical: res.medical,
            fitness: res.fitness,
            deduction: res.deduction,
            tax: res.tax,
            salaryMonth: res.salaryMonth,
            status: returnStatus()
          });
        } catch (error) {
          console.error("Error fetching Salary:", error);
        } finally {
          setLoading(false);
        }
      } else {
        setSalaryData({
          name: "",
          grossSalary: 0,
          netSalary: 0,
          medical: 0,
          fitness: 0,
          deduction: 0,
          tax: 0,
          salaryMonth: "",
          status: "",
        });
      }
    };
    fetchSalary();
  }, [salaryId]);

  const handleClose = () => {
    setOpenModal(false);
    setOpenSalary(false);
    setOpen(false);
    fetchSalaries(true);
    setSalaryId(null);
    setDeleteId(null);
    setUpdateId(null);
  };

  const headingTableCellStyle = {
    color: "#fff",
    textAlign: "center",
    borderBottom: "2px solid #1F1F1F",
    fontSize: { xs: "0.8rem", sm: "1rem" },
    backgroundColor: '#1F1F1F'
  };

  const dataTableCellStyle = (id, hover) => {
    return {
      color: hover === id ? "#FF5722" : "#fff",
      textAlign: "center",
      borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
      fontSize: { xs: "0.8rem", sm: "1rem" },
      padding: '10px 16px',
      backgroundColor: '#292929'
    };
  }

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        textAlign="center"
      >
        <CircularProgress size={50} sx={{ color: "#FF5722" }} />
        <Typography variant="h6" sx={{ marginTop: "18px", color: "#fff" }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <div className="app-container" style={{ color: "#fff", display: "flex" }}>
        {role === "admin" && <SideNavBar />}
        {role === "hr" && <HrSideNavBar />}
        <div style={{ flex: 1, margin: `${isSmallScreen ? '2.6rem' : '0.5rem'} 0.5rem 0.5rem 0.5rem` }}>
          <Box sx={{ backgroundColor: "#000", marginTop: { xs: 1, md: 0 } }}>
            <Grid
              container
              sx={{
                alignItems: "center",
                justifyContent: { xs: "center", md: "space-between" },
                flexDirection: { xs: "column", md: "row" },
                padding: "1rem",
                gap: { xs: 1, md: 0 },
              }}
            >
              <Grid item>
                <h1>Salaries</h1>
              </Grid>
              <>
                {!isSmallScreen ? (
                  <Grid
                    item
                    display="flex"
                    sx={{
                      flexDirection: { xs: "column", md: "row" },
                      alignItems: "center",
                      justifyContent: { xs: "center", md: "flex-end" },
                      gap: { xs: 1, md: 1 },
                    }}
                  >
                    <Grid
                      item
                      style={{
                        border: "1px solid #D0521B",
                        borderRadius: "5px",
                        padding: "0.25rem 1rem",
                      }}
                    >
                      <span
                        style={{
                          display: "block",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "18px",
                        }}
                      >
                        {totalSalaries.payableSalary}
                      </span>
                      <span style={{ fontSize: "14px" }}>
                        Total Salaries Payable in {totalSalaries.month}
                      </span>
                    </Grid>
                    <Grid item>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Salary Month"
                          views={["month", "year"]}
                          onChange={handleMonthChange}
                          onClose={handleDateClose}
                          inputFormat="MM/YYYY"
                          sx={{
                            "& .MuiInputBase-root": {
                              color: "#fff",
                              borderColor: "#FF5722",
                              "& fieldset": {
                                borderColor: "#FF5722",
                              },
                              "&:hover fieldset": {
                                borderColor: "#FF5722",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#FF5722",
                              },
                            },
                            "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                              color: "#fff",
                            },
                            "& .MuiFormLabel-root": {
                              color: "#fff",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        onClick={handleMonthlySalaryReport}
                        sx={{
                          width: '100%',
                          height: '100%',
                          backgroundColor: "#fff",
                          color: "black",
                          "&:hover": {
                            backgroundColor: "#e1e1e1",
                          },
                        }}
                      >
                        Monthly Salary Report
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        onClick={handleSalaryMail}
                        sx={{
                          width: '100%',
                          height: '100%',
                          backgroundColor: "#fff",
                          color: "black",
                          "&:hover": {
                            backgroundColor: "#e1e1e1",
                          },
                        }}
                      >
                        Mail Salary Slips
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        onClick={handleSalary}
                        sx={{
                          width: '100%',
                          height: '100%',
                          backgroundColor: "#fff",
                          color: "black",
                          "&:hover": {
                            backgroundColor: "#e1e1e1",
                          },
                        }}
                      >
                        Generate Salaries
                      </Button>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid
                    item
                    display="flex"
                    sx={{
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                      flexWrap: "wrap",
                    }}
                  >
                    <Grid item xs={12}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Salary Month"
                          views={["month", "year"]}
                          onChange={handleMonthChange}
                          onAccept={handleDateClose}
                          inputFormat="MM/YYYY"
                          sx={{
                            width: "100%",
                            "& .MuiInputBase-root": {
                              color: "#fff",
                              borderColor: "#FF5722",
                              "& fieldset": {
                                borderColor: "#FF5722",
                              },
                              "&:hover fieldset": {
                                borderColor: "#FF5722",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#FF5722",
                              },
                            },
                            "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                              color: "#fff",
                            },
                            "& .MuiFormLabel-root": {
                              color: "#fff",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid
                      container
                      item
                      xs={12}
                      sx={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        gap: 1,
                      }}
                    > 
                      <Grid item xs={5.8}>
                        <Button
                          variant="contained"
                          onClick={handleMonthlySalaryReport}
                          sx={{
                            width: "100%",
                            height: "100%",
                            fontSize: "12px",
                            backgroundColor: "#fff",
                            color: "black",
                            "&:hover": {
                              backgroundColor: "#e1e1e1",
                            },
                            fontWeight: '600'
                          }}
                        >
                          Monthly Salary Report
                        </Button>
                      </Grid>
                      <Grid item xs={5.8}>
                        <Button
                          variant="contained"
                          onClick={handleSalaryMail}
                          sx={{
                            width: "100%",
                            height: "100%",
                            fontSize: "12px",
                            backgroundColor: "#fff",
                            color: "black",
                            "&:hover": {
                              backgroundColor: "#e1e1e1",
                            },
                            fontWeight: '600'
                          }}
                        >
                          Mail Salary Slips
                        </Button>
                      </Grid>
                      <Grid item xs={5.8}>
                        <Button
                          variant="contained"
                          onClick={handleSalary}
                          sx={{
                            width: "100%",
                            height: "100%",
                            fontSize: "12px",
                            backgroundColor: "#fff",
                            color: "black",
                            "&:hover": {
                              backgroundColor: "#e1e1e1",
                            },
                            fontWeight: '600'
                          }}
                        >
                          Generate Salaries
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </>
            </Grid>
            {salaries.length === 0 ? (
              <Typography
                variant="h6"
                sx={{ color: "#fff", textAlign: "center" }}
              >
                No Data Yet
              </Typography>
            ) : (
              <>
                {!isSmallScreen ? (
                  <TableContainer sx={{ overflowX: "auto", maxWidth: "100vw" }}>
                    <Table style={{
                      borderRadius: "25px",
                      borderCollapse: "separate",
                      overflow: "hidden",
                    }}>
                      <TableHead>
                        <TableRow>
                          <TableCell style={headingTableCellStyle}>
                            ID
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Employee Name
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Salary Month
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Gross Salary
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Net Salary
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Reimbursement
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Deduction
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Status
                          </TableCell>
                          <TableCell style={headingTableCellStyle}>
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {salaries.map((salary, id) => (
                          <TableRow
                            key={id}
                            style={{
                              cursor: "pointer",
                              height: '60px'
                            }}
                            onMouseEnter={() => setHover(id)}
                            onMouseLeave={() => setHover(null)}
                            onClick={() => handleSalaryDetail(salary._id)}
                          >
                            <TableCell style={dataTableCellStyle(id, hover)}>
                              {(page - 1) * 10 + id + 1}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(id, hover)}>
                              {salary.name}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(id, hover)}>
                              {salary.salaryMonth}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(id, hover)}>
                              {salary.grossSalary}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(id, hover)}>
                              {salary.netSalary}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(id, hover)}>
                              {salary.fitness + salary.medical}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(id, hover)}>
                              {salary.deduction + salary.tax}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(id, hover)}>
                              {salary.status}
                            </TableCell>
                            <TableCell style={dataTableCellStyle(id, hover)}>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  marginRight: "5px",
                                }}
                                aria-label="view"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDownload(salary.userId, salary.salaryMonth, salary.name);
                                }}
                                disabled={salarySlipDownloadIds.includes(salary.userId)}
                              >
                                {salarySlipDownloadIds.includes(salary.userId) ? <CircularProgress size={18} sx={{color: 'white'}} /> : <DownloadIcon fontSize="inherit"/>}
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#9500ae",
                                  marginRight: "5px",
                                }}
                                aria-label="view"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMail(salary.userId, salary.salaryMonth);
                                }}
                              >
                                <EmailOutlinedIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  marginRight: "5px",
                                }}
                                aria-label="view"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSalaryDetail(salary._id);
                                }}
                              >
                                <VisibilityIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  marginRight: "5px",
                                }}
                                aria-label="edit"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectSalary(salary._id);
                                }}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#F44336",
                                  marginRight: "5px",
                                }}
                                aria-label="delete"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(salary._id);
                                }}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter style={{ backgroundColor: "#1F1F1F" }}>
                        <TableRow>
                          <TableCell
                            colSpan={100}
                            style={{
                              color: "white",
                              border: "none",
                              textAlign: "center",
                            }}
                          >
                            <Pagination
                              count={totalPages}
                              variant="outlined"
                              color="primary"
                              page={page}
                              onChange={(e, value) => {
                                setPage(value);
                              }}
                              sx={{
                                display: "inline-block",
                                "& .MuiPaginationItem-root": {
                                  color: "#fff",
                                  borderColor: "#fff",
                                  transition: "all 0.3s ease",
                                  "&:hover": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                  "&.Mui-selected": {
                                    backgroundColor: "#FF5722",
                                    color: "#fff",
                                    borderColor: "#FF5722",
                                  },
                                },
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                ) : (
                  <Grid container spacing={1} justifyContent='center'>
                    {salaries.map((salary, id) => (
                      <Grid item xs={12} key={id}>
                        <Card ref = {id+1 === salaries.length ? ref : null}
                          sx={{
                            backgroundColor: "#101010",
                            color: "#fff",
                          }}
                          onMouseEnter={() => setHover(id)}
                          onMouseLeave={() => setHover(null)}
                          onClick={() => handleSalaryDetail(salary._id)}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <CardContent>
                              <Typography variant="h6">
                                {salary.name}
                              </Typography>
                              <Typography variant="body2">
                                Salary Month: {salary.salaryMonth}
                                <br />
                                Net Salary: {salary.netSalary}
                              </Typography>
                            </CardContent>
                            <CardActions sx={{display: 'flex', flexWrap: 'wrap', rowGap: '10px', columnGap: '5px', justifyContent: 'start'}}>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  marginLeft: '0px'
                                }}
                                aria-label="view"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDownload(salary.userId, salary.salaryMonth, salary.name)
                                }}
                                disabled={salarySlipDownloadIds.includes(salary.userId)}
                              >
                                {salarySlipDownloadIds.includes(salary.userId) ? <CircularProgress size={22} sx={{color: 'white'}} /> : <DownloadIcon fontSize="inherit"/>}
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#9500ae",
                                  marginLeft: '0px'
                                }}
                                aria-label="view"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMail(salary.userId, salary.salaryMonth);
                                }}
                              >
                                <EmailOutlinedIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#1976D2",
                                  marginLeft: '0px'
                                }}
                                aria-label="view"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSalaryDetail(salary._id);
                                }}
                              >
                                <VisibilityIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#4CAF50",
                                  marginLeft: '0px'
                                }}
                                aria-label="edit"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  selectSalary(salary._id);
                                }}
                              >
                                <EditIcon fontSize="inherit" />
                              </IconButton>
                              <IconButton
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#F44336",
                                  marginLeft: '0px'
                                }}
                                aria-label="delete"
                                size="medium"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOpen(salary._id);
                                }}
                              >
                                <DeleteIcon fontSize="inherit" />
                              </IconButton>
                            </CardActions>
                          </Box>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                )}
              </>
            )}
          </Box>
          <Dialog
            open={openSalary}
            maxWidth
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                opacity: 0.9,
                color: "#fff",
                padding: "5px",
                maxWidth: { xs: "80%", md: "40%" },
                border: "2px solid #D0521B",
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "22px",
                fontWeight: "bold",
              }}
            >
              {salaryData.name}
              <IconButton
                onClick={handleClose}
                sx={{
                  color: "#fff",
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                sx={{ borderTop: "2px solid #D0521B", paddingTop: "1rem" }}
              >
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Employee name:</b> {salaryData.name}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Salary Month:</b> {salaryData.salaryMonth}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Gross Salary:</b> {salaryData.grossSalary}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Net Salary:</b> {salaryData.netSalary}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Medical Allowance:</b> {salaryData.medical}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Fitness Allowance:</b> {salaryData.fitness}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Tax:</b> {salaryData.tax}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Deduction:</b> {salaryData.deduction}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <b>Status:</b> {salaryData.status}
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
          <Dialog
            open={open}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#212121",
                color: "#fff",
                padding: "15px",
              },
              "& .MuiDialogTitle-root": {
                padding: "5px",
              },
              "& .MuiDialogContentText-root": {
                color: "#fff",
              },
              "& .MuiDialogContent-root": {
                padding: "5px",
              },
              "& .MuiDialogActions-root": {
                padding: "5px",
              },
            }}
          >
            <DialogTitle>Confirm Deletion</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete this salary?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                sx={{
                  backgroundColor: "#A6A6A6",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#B8B8B8" },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                sx={{
                  backgroundColor: "#E5622D",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#D0521B" },
                }}
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          <AddSalary
            open={openModal}
            handleClose={handleClose}
            salaryId={updateId}
          />
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {isSmallScreen && <Grid container width='100%' height='10vh' alignItems='center' justifyContent='center' style={{position: 'fixed', bottom: (isFetchingSalaries ? '20px' : '-100px'), transition: 'bottom 0.5s ease'}}>
              <CircularProgress size="3rem" sx={{color: "#FF5722"}} />
            </Grid>}
    </>
  );
};

export default Salaries;
